<template>
  <div class="plthumb" v-bind:class='{grid: !fullsizeview, full: fullsizeview, initialized: !hoverLock, addedtosheet: photoAddedToSheet}' @mouseover='initializeCarousel = true' @touchstart='initializeCarousel = true'>
    <div class="difficulty-indicators" v-if="difficulty">
      <div class="frequency" v-bind:class="[difficulty.frequency]"></div>
      <div class="price" v-bind:class="[difficulty.price]"></div>
      <div class="usability" v-bind:class="[difficulty.usability]"></div>
    </div>
    <div class="overlay-container" v-if="initializeCarousel">
      <div class="bottom-overlay" @click="addToPullSheet(photoAddedToSheet)" v-if='showpullsheet'>
        <span v-if="!photoAddedToSheet">Add</span><span class="added" v-else>Added</span>
      </div>
      <div class="next-button">
        <i class="material-icons" @click='advanceCarousel'>keyboard_arrow_right</i>
      </div>
      <div class="previous-button">
        <i class="material-icons" @click='advanceCarousel("backward")'>keyboard_arrow_left</i>
      </div>
    </div>

    <carousel :perPage='1' :paginationEnabled='false' :loop='true' ref='carousel' v-if='initializeCarousel' @pageChange='carouselPageChange'>
      <slide v-for="photo, index in filteredphotos" :key='index'>
        <router-link :to='"/location/"+PL.reneeid'><img :src="'https://img.therenees.com/'+photo.u" /></router-link>
      </slide>
    </carousel>
    <router-link :to='"/location/"+PL.reneeid' v-if='!initializeCarousel && lazy'><img v-lazy="'https://img.therenees.com/'+filteredphotos[0].u" /></router-link>
    <router-link :to='"/location/"+PL.reneeid' v-if='!initializeCarousel && !lazy'><img :src="'https://img.therenees.com/'+filteredphotos[0].u" /></router-link>



    <h4>{{PL.reneeid}}</h4>
  </div>
</template>

<script>
export default {
  name: 'PLThumb',
  props: [
    'PL',
    'fullsizeview',
    'tagids',
    'photofilter',
    'showpullsheet',
    'lazy'
  ],
  watch: {
    filteredphotos: function () {
      if (this.$refs.carousel !== undefined) this.$refs.carousel.goToPage(0)
    },
    fullsizeview: function () {

    },
    initializeCarousel: function () {
      if (this.initializeCarousel) {
        setTimeout(() => {
          this.hoverLock = false
        }, 10)
      }
    }
  },
  data () {
    return {
      initializeCarousel: false,
      hoverLock: true,
      currentSlide: 0,
      activePullSheet: this.$root.activePullSheet,
      photoAddedToSheet: false,
      difficulty: false
    }
  },
  computed: {
    filteredphotos () {
      var response = this.$root.filterListingPhotos(this.PL.photos, this.photofilter, this.tagids)
      if (this.PL.pickedPhotos !== undefined) {
        this.PL.pickedPhotos.forEach(pickedphoto => {
          var existingindex = response.findIndex(function (photo) {
            return photo.u === pickedphoto
          })
          if (existingindex !== -1) response.splice(existingindex, 1)
          response.unshift({u: pickedphoto})
        })
      }
      return response
    }
  },
  methods: {
    advanceCarousel: function (direction) {
      this.$refs.carousel.advancePage(direction)
    },
    carouselPageChange: function () {
      this.currentSlide = this.$refs.carousel.currentPage
      this.photoAddedToSheet = false
      this.activePullSheet.items.forEach(photo => {
        if (photo.url === this.filteredphotos[this.$refs.carousel.currentPage].u) this.photoAddedToSheet = true
      })
    },
    addToPullSheet: function () {
      if (this.photoAddedToSheet) return
//       this.pullSheet.photos.push(this.$refs.carousel.currentPage)
      this.$root.itemToAdd.plno = this.PL.plno
      this.$root.itemToAdd.url = this.filteredphotos[this.$refs.carousel.currentPage].u
      this.$root.itemToAdd.trigger = true
      this.photoAddedToSheet = true
    },
    updateDifficulty: function () {
      this.difficulty = this.$root.difficulty[this.PL.plno]
      if (!this.difficulty.frequency && !this.difficulty.price && !this.difficulty.usability) this.difficulty = false
    }
  },
  created: function () {
    if (this.$root.authorizedUser) {
      if (this.$root.difficulty[this.PL.plno]) {
        this.difficulty = this.$root.difficulty[this.PL.plno]
        if (!this.difficulty.frequency && !this.difficulty.price && !this.difficulty.usability) this.difficulty = false
      } else {
        setTimeout(() => {
          this.updateDifficulty()
        }, 1000)
      }
    }
  },
  mounted: function () {
    if (this.$root.isMobile) this.initializeCarousel = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/_mixins.scss";
.plthumb {
/*   transition: width .1s; */
  margin-bottom: .5%;
  line-height: 0;
  position: relative;
  h4 {
    line-height: 1;
    font-weight: 500;
    position: absolute;
    left: 0px;
    top: 0px;
    color: #FFF;
    margin: 0px;
    padding: .35em;
    z-index: 10;
    font-size: 14px;
    width: 80%;
    background: linear-gradient(90deg, rgba(161,99,165,1) 0%, rgba(161,99,165,0) 100%);
    color-adjust: exact;
    -webkit-print-color-adjust: exact;
    @include bp(most) {
      font-size: 16px;
    }
  }
}
.plthumb.grid {
  display: inline-block;
/*
  width: 24.5%;
  max-height: 16vw;
*/
  width: 49%;
  height: 30vw;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;

  }
  @include bp(most) {
    width: 32.7%;
    height: 21vw;
  }
  @include bp(large) {
    width: 24%;
    height: 15.7vw;
  }
}
.plthumb.full {
 width: 100%;
/*  height:  66.808vw; */

 img {
    width: 100%;
 }
 .VueCarousel-wrapper {
   height:  65.5vw;
 }
}
img {
/*   height: 100%; */
}
.overlay-container {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
  pointer-events: none;
  display: none;
  @include bp(most) {
    display: block;
  }
  .bottom-overlay {
    pointer-events: auto;
    position: absolute;
    bottom: -20px;
    width: 50%;
    right: 0px;
    color: #FFF;
    text-align: right;
    opacity: 0;
    transition: opacity .5s;
    background: rgba(161,99,165,.5);
    background: linear-gradient(90deg, rgba(161,99,165,0) 0%, rgba(161,99,165,.5) 100%);
    transition: bottom .25s;
    padding-right: .25em;
    box-sizing: border-box;
    span {
      display: inline-block;
      line-height: 1.75;
      font-size: 1.25em;
      padding-left: .25em;
      vertical-align: middle;
      cursor: pointer;
      &.added {
        cursor: default;
      }
    }
  }
  .next-button, .previous-button {
    pointer-events: auto;
    position: absolute;
    background: rgba(161,99,165,.5);
    line-height: 1;
    padding: 0;
    color: #FFF;
    top: 45%;
    margin-top: -12px;
		@include noselect();
		cursor: pointer;
		i {
      font-size: 36px;
  		vertical-align: middle;
		}
/*
    .full & {
      i {
        font-size: 64px;
      }
    }
*/
  }
  .next-button {
    transition: right .25s;
    right: -38px;
  }
  .previous-button {
    transition: left .25s;
    left: -38px;
  }
  .plthumb.initialized:hover & .bottom-overlay, .plthumb.addedtosheet & .bottom-overlay {
    /* bottom: 0px; */
    opacity: 1;
  }
  .plthumb.initialized:hover & .next-button {
    right: 0px;
  }
  .plthumb.initialized:hover & .previous-button {
    left: 0px;
  }
  .plthumb.initialized:hover & .bottom-overlay {
    bottom: 0px;
  }
}
.difficulty-indicators {
  position: absolute;
  z-index: 5;
  top: 0px;
  right: 0px;
  width: 100px;
  font-size: 0px;
  text-align: right;
  div {
    display: inline-block;
    height: 16px;
    width: 16px;
    margin: 5% 5% 0 0;
    vertical-align: middle;
    border-radius: 16px;
    border: 1px solid #EEE;
    &.green {
      background-color: #2ecc40;
      border-color: #2ecc40;
    }
    &.orange {
      background-color: #ff851b;
      border-color: #ff851b;
    }
    &.red {
      background-color: #ef1607;
      border-color: #ef1607;
    }
    &.yellow {
      background-color: #ffe21f;
      border-color: #ffe21f;
    }
  }
}
</style>
<style lang="scss">
.plthumb.full {
 .VueCarousel-wrapper {
   height:  65.5vw;
 }
}
div.VueCarousel-slide {
  flex-basis: fit-content;
}
</style>



// WEBPACK FOOTER //
// PLThumb.vue?e059473a